import { render, staticRenderFns } from "./PriorityTypeFilter.vue?vue&type=template&id=621bf544&"
import script from "./PriorityTypeFilter.vue?vue&type=script&lang=js&"
export * from "./PriorityTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports